"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCourierClient = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _package = _interopRequireDefault(require("../package.json"));

var _urql = require("urql");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("isomorphic-fetch");

var createCourierClient = function createCourierClient(params, defaults) {
  if ("client" in params) {
    return params.client;
  }

  var headers;
  var jwtParams = params;

  if (jwtParams.authorization) {
    headers = {
      authorization: "Bearer ".concat(jwtParams.authorization),
      "x-courier-client-key": jwtParams.clientKey
    };

    if (jwtParams.clientSourceId) {
      headers["x-courier-client-source-id"] = jwtParams.clientSourceId;
    }
  } else {
    var _ref = params,
        clientKey = _ref.clientKey,
        userId = _ref.userId,
        userSignature = _ref.userSignature,
        clientSourceId = _ref.clientSourceId;
    headers = {
      "x-courier-client-key": clientKey,
      "x-courier-user-id": userId
    };

    if (clientSourceId) {
      headers["x-courier-client-source-id"] = clientSourceId;
    }

    if (userSignature) {
      headers["x-courier-user-signature"] = userSignature;
    }

    if (!clientKey || !userId) {
      return;
    }
  } // add client version and platform


  headers = _objectSpread(_objectSpread({}, headers), {}, {
    "x-courier-client-version": _package["default"].version
  });
  return (0, _urql.createClient)({
    url: params.apiUrl || (defaults === null || defaults === void 0 ? void 0 : defaults.apiUrl) || "".concat(undefined || "https://api.courier.com", "/client/q"),
    requestPolicy: "network-only",
    fetchOptions: function fetchOptions() {
      return {
        headers: headers
      };
    }
  });
};

exports.createCourierClient = createCourierClient;